<template class="full-height">
  <div class="member-container full-height">
    <el-dialog
      :fullscreen="true"
      v-loading="listLoading"
      :visible.sync="dialogFormVisible"
      :title="formData.id ? '編輯' : '新增'"
      @closed="onDialogClosed"
    >
      <el-card class="box-card">
        <el-form size="mini" ref="decForm" :model="formData" :label-width="formLabelWidth">
          <el-form-item
            label="類別"
            prop="type"
            :rules="[{ required: true, message: '請選擇類別', trigger: 'blur' }]"
          >
            <el-select v-model="formData.type" placeholder="請選擇類別">
              <el-option
                v-for="item in typeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="內容"
            :label-width="formLabelWidth"
            prop="description"
            :rules="[{ required: true, message: '請輸入內文', trigger: 'blur' }]"
          >
            <div>
              <tinymce ref="tinymce" v-model="formData.description" :height="500" :type="32" />
            </div>
          </el-form-item>
        </el-form>
        <div></div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('decForm')">確定</el-button>
        <el-button type="danger" @click="onDialogClosed()">取消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true">
          <el-form-item>
            <el-button type="success" size="mini" @click="addData">建立</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
        >
          <el-table-column :label="'ID'" prop="id" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column label="類別" prop="type" align="left" width="130">
            <template slot-scope="{ row }">
              <span>{{ showType(row.type) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="更新者" prop="buildUser" align="left" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.buildUser }}</span>
            </template>
          </el-table-column>

          <el-table-column label="更新時間" prop="BuildDate" align="left" width="150">
            <template slot-scope="{ row }">
              <span>{{ row.updateDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="primary"
                icon="el-icon-edit"
                @click="editData(scope.row)"
              >
                編輯資料
              </el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'刪除'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                icon="el-icon-key"
                @click="deleteDec(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  deleteDescription,
  deleteHashTag,
  getDescription,
  getHashTag,
  getSettingDescriptionTypeList,
  saveDescription,
  saveHashTag,
} from '@/api/tcSetting'
import waves from '@/directive/waves' // waves directive
import Tinymce from '@/components/Tinymce'
import { encodeContentBase64 } from '@/utils/funcs'
import { nextTick } from 'process'
var defaultFormData = {
  id: null,
  type: null,
  description: '',
}
export default {
  name: 'HashTag',
  components: { Tinymce },
  directives: { waves },
  data() {
    return {
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      dialogFormVisible: false,
      formData: {},
      tableKey: 0,
      list: null,
      listLoading: true,
      typeOption: [],
    }
  },
  computed: {
    showType() {
      return function (value) {
        switch (value) {
          case 1:
            return '服務條款'
          case 2:
            return '隱私權政策'
          case 3:
            return '駐站申請'
          case 4:
            return '領隊說明'
        }
      }
    },
  },
  async created() {
    await this.getType()
    await this.getList()
  },
  methods: {
    async deleteDec(row) {
      let vm = this
      this.$confirm('確定刪除該筆資料?', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          vm.loadingHanlder(true)
          let resp = await deleteDescription({ id: row.id })
          if (resp.success) {
            await vm.getList()
            vm.$message({
              message: '操作成功',
              type: 'success',
            })
          }
          vm.loadingHanlder(false)
        })
        .catch(err => {
          console.error(err)
        })
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    async getType() {
      await getSettingDescriptionTypeList().then(response => {
        this.typeOption = response
      })
    },
    onDialogClosed() {
      this.$refs['decForm'].clearValidate()
      this.formData = JSON.parse(JSON.stringify(defaultFormData))
      this.$refs['tinymce'].setValue('') //重置內容
      this.dialogFormVisible = false
    },
    addData(row) {
      let vm = this
      vm.formData = JSON.parse(JSON.stringify(defaultFormData))
      vm.dialogFormVisible = true
      nextTick(() => {
        this.$refs['decForm'].clearValidate()
      })
    },
    editData(d) {
      console.log(d)
      const vm = this
      vm.formData = JSON.parse(JSON.stringify(d))
      vm.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['tinymce'].setValue(vm.formData.description)
      })
    },

    saveData(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loadingHanlder(true)
          // 富文本 base64 編碼(避免 AWS WAF 誤擋 403)；用複製物件避免污染響應式 formData（後端 Base64ContentCodec.Decode 還原後再存檔）。
          saveDescription({ ...vm.formData, description: encodeContentBase64(vm.formData.description) })
            .then(async response => {
              console.log(response)
              await vm.getList()
              vm.dialogFormVisible = false
              this.loadingHanlder(false)
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            })
            .catch(error => {
              console.log(error.response.data)
              this.loadingHanlder(false)
            })
        } else {
          return false
        }
      })
    },

    async getList() {
      this.loadingHanlder(true)
      var res = await getDescription()
      console.log(res)
      this.list = res.data
      this.loadingHanlder(false)
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
